












import { createComponent, computed } from "@vue/composition-api";
import { useGetters, useActions, useRouter } from "@/helpers";

export default createComponent({
  setup(props, context) {
    const {
      user,
      currentChat,
      loggedIn,
    } = useGetters("user", "currentChat", "loggedIn");
    const { router, route } = useRouter();
    const userName = computed(() => loggedIn.value ? user.value!.name : "");
    async function logOut() {
      await useActions("logOut").logOut();
      if (route.value.matched.some(({ meta }) => meta.requiresAuth)) {
        router.push("/");
      }
    }

    return {
      currentChat,
      loggedIn,
      logOut,
      userName,
    };
  },
});
